import LicenceTreeBase from './LicenceTreeBase';

/**
 * EightByEightLicenceTree
 *
 * Service profile licence editor — status only (no volume).
 * Renders the FormLabel + description wrapper for use inside a form.
 */
const EightByEightLicenceTree = ({ catalogue, value, onChange, darkMode }) => (
    <LicenceTreeBase
        catalogue={catalogue}
        value={value}
        onChange={onChange}
        darkMode={darkMode}
        hasVolume={false}
        showFormLabel={true}
    />
);

export default EightByEightLicenceTree;
